import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { RiDeleteBin5Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


import axios from 'axios';
import { BaseUrl } from '../App';
const Add = () => {
  const location = useLocation();
  const serviceName = location.state?.serviceName || 'Unknown Service';
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [multipleQty, setMultipleQty] = useState(false); // Toggle state for multiple quantity
  const [addons, setAddons] = useState([]); // State to store add-ons
  const [editIndex, setEditIndex] = useState(null); // State for edit functionality
  const [selectedService, setSelectedService] = useState(''); // For the new dropdown
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    title: '', price: '', hours: '', minutes: '', serviceImage: '', addon_service_description :"",multipleQty: "N"  // Change from "" to "D" as default
  });
  const [deleteIndex, setDeleteIndex] = useState(null); // Track index for deletion
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Toggle delete modal
  const [loading, setLoading] = useState(false);
  const serviceId = location.state?.serviceId;  // Get the serviceId from location state
  const servicesList = [
    { id: 1, name: 'Inside Fridge', icon: '🍽️' },
    { id: 2, name: 'Inside Oven', icon: '🍳' },
    { id: 3, name: 'Inside Window', icon: '🪟' },
    { id: 4, name: 'Carpet Cleaning', icon: '🧼' },
    { id: 5, name: 'Green Cleaning', icon: '🌱' },
    { id: 6, name: 'Pets Care', icon: '🐾' },
    { id: 7, name: 'Title Cleaning', icon: '🏠' },
    { id: 8, name: 'Wall Cleaning', icon: '🖼️' },
    { id: 9, name: 'Laundry', icon: '👚' },
  ];
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  // Toggle slider visibility
  const toggleSlider = () => {
    setIsSliderOpen(!isSliderOpen);
  };

  // Reset form fields
  const resetForm = () => {
    setFormData({ title: '', price: '', hours: '', minutes: '', serviceImage: '', multipleQty: '' });
  };

  // Toggle multiple quantity
  // const toggleMultipleQty = () => {
  //   setFormData({ ...formData, multipleQty: !formData.multipleQty });
  // };
  const toggleMultipleQty = () => {
    setFormData({ 
      ...formData, 
      multipleQty: formData.multipleQty === "Y" ? "N" : "Y" 
    });
  };
  useEffect(() => {
    if (serviceId) {
      fetchAddons(serviceId); // Fetch add-ons based on the serviceId
    }
  }, [serviceId]); // Make sure to re-fetch when serviceId changes or page loads

  const fetchAddons = async (serviceId) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/service_addons.php`, {
        action: 'get_addons_of_selected_service',
        api_key: '1',  // Replace with the correct API key
        service_id: serviceId // Pass the service ID dynamically
      });

      if (response.data.status === 'true') {
        const fetchedAddons = response.data.response.map(addon => ({
          ...addon,
          multipleQty: addon.multipleqty  // Default to "D" if null
        }));
        setAddons(fetchedAddons);
      } else {
        console.error('Error:', response.data.response);
      }
    } catch (error) {
      console.error('Error fetching add-ons: ', error); // Handle any network or server errors
    }
    finally {
      setLoading(false);
    }
  };
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const addonData = {
      api_key: "1",
      service_id: serviceId,
      addon_service_name: formData.title,
      base_price: formData.price,
      maxqty: formData.maxqty || "1", // Default to 1 if not provided
      image: formData.serviceImage,
      multipleQty: formData.multipleQty,
      status: 'E',
      predefine_image: selectedService,
      predefine_image_title: '',
      aduration: `${formData.hours || 0} hours ${formData.minutes || 0} minutes`,
      addon_service_description: formData.addon_service_description,
    };

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/service_addons.php`, {
        action: "add_service_addon",
        ...addonData
      });

      if (response.data.status === "true") {
        setSuccessMessage("Addon Service Added Successfully!");
        const newAddon = {
          id: response.data.response.addon_service_id, // Assuming API returns the new addon ID
          addon_service_name: formData.title,
          base_price: formData.price,
          maxqty: formData.maxqty || "1",
          image: formData.serviceImage,
          multipleqty: formData.multipleQty,
          status: 'E',
          predefine_image: selectedService,
          aduration: `${formData.hours || 0} hours ${formData.minutes || 0} minutes`,
          addon_service_description: formData.addon_service_description,
        };
        setAddons([...addons, newAddon]); // Add the new addon to the state
        setIsSliderOpen(false); // Close the slider
        resetForm(); // Reset the form
      } else {
        setError("Error adding addon service: " + response.data.response);
      }
    } catch (error) {
      console.error("Error adding addon service:", error);
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  //  handle delete
  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  // Confirm deletion
  const confirmDelete = async () => {
    setLoading(true);
    try {
      const addonToDelete = addons[deleteIndex]; // Get the addon to delete
      const response = await axios.post(`${BaseUrl}/backend/api/service_addons.php`, {
        action: "delete_service_addon",
        api_key: "1",  // Use the correct API key
        id: addonToDelete.id,  // Pass the addon id to delete
      });

      if (response.data.status === "true") {
        setSuccessMessage("Addon service deleted successfully!")
        // alert("Addon service deleted successfully");

        // Update the frontend state to remove the deleted addon
        const updatedAddons = addons.filter((_, i) => i !== deleteIndex);
        setAddons(updatedAddons);
        console.log("api delete is work", response.data)
      } else {
        alert("Error deleting addon service: " + response.data.response);
      }
    } catch (error) {
      console.error("Error deleting addon service:", error);
      alert("An error occurred while deleting the addon. Please try again later.");
    } finally {
      setIsDeleteModalOpen(false);  // Close the modal
      setDeleteIndex(null);  // Reset the delete index
      
        setLoading(false);
     
    }
  };


  // Cancel deletion
  const cancelDelete = () => {
    setIsDeleteModalOpen(false);
    setDeleteIndex(null);
  };
  // Handle edit
  const handleEdit = (index) => {
    const addonToEdit = addons[index]; // Get the addon to edit based on the index
    setFormData({
      title: addonToEdit.addon_service_name,
      price: addonToEdit.base_price,
      maxqty: addonToEdit.maxqty,
      hours: addonToEdit.aduration.split(" ")[0], // Extracting hours
      minutes: addonToEdit.aduration.split(" ")[2], // Extracting minutes
      serviceImage: addonToEdit.image,
      multipleQty: addonToEdit.multipleqty === "Y" ? "N" : "Y", // Ensure it uses E/D
      addon_service_description: addonToEdit.addon_service_description
    });
    setSelectedService(addonToEdit.predefine_image); // Set predefined image
    setEditIndex(index); // Set the index for the addon being edited
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Ensure serviceImage is a string, handle it if it's an array or file
    let image = formData.serviceImage;
    if (Array.isArray(image)) {
      // If it's an array (e.g., multiple files), convert to a string (e.g., using a comma-separated string or base64 encoding)
      image = image.join(','); // Or handle this case differently based on your needs
    }

    const addonData = {
      api_key: "1", // API key
      id: addons[editIndex].id, // ID of the addon being edited
      addon_service_name: formData.title,
      base_price: formData.price,
      maxqty: formData.maxqty,
      image: image,  // Pass the image as a string
      multipleqty: formData.multipleQty,
      status: 'D',
      predefine_image: selectedService,
      predefine_image_title: '',
      aduration: `${formData.hours} hours ${formData.minutes} minutes`,
      addon_service_description:`${formData.addon_service_description} addon_service_description`
    };

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/service_addons.php`, {
        action: "edit_service_addon",
        ...addonData
      });

      if (response.data.status === "true") {
        setSuccessMessage("Addon service updated successfully!")
        // alert("Addon service updated successfully");
        const updatedAddons = [...addons];
        updatedAddons[editIndex] = {
          ...updatedAddons[editIndex],
          addon_service_name: formData.title,
          base_price: formData.price,
          maxqty: formData.maxqty,
          image: image,
          aduration: `${formData.hours} hours ${formData.minutes} minutes`,
          predefine_image: selectedService
        };
        setAddons(updatedAddons);
        setEditIndex(null);
      } else {
        alert("Error updating addon");
      }
    } catch (error) {
      console.error("Error updating addon service:", error);
      alert("An error occurred while updating the addon. Please try again later.");
    }
    finally {
      setLoading(false);
    }
  };
  const toggleStatus = async (index) => {
    setLoading(true);
    const addonToUpdate = addons[index];
    const newStatus = addonToUpdate.status === 'D' ? 'E' : 'D'; // Toggle between 'D' and 'E'

    // Prepare the data to send in the API request
    const updateData = {
      api_key: "1", // API key
      id: addonToUpdate.id, // Addon ID
      status: newStatus, // New status ('E' or 'D')
    };

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/service_addons.php`, {
        action: "change_service_addon_status",  // Action to change status
        ...updateData,
      });

      if (response.data.status === "true") {
        setSuccessMessage("Addon Service  Status Update Successfully!")
        // alert("Addon status updated successfully");

        // Update the status in the state
        const updatedAddons = [...addons];
        updatedAddons[index].status = newStatus; // Update status in the state
        setAddons(updatedAddons);  // Update the state
      } else {
        alert("Error updating addon status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred while updating the status. Please try again later.");
    }
    finally {
      setLoading(false);
    }
  };



  return (
   
         <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6 xl:px-52">
                    {successMessage && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                <span className="block sm:inline">{successMessage}</span>
              </div>
            )}

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
                <span className="block sm:inline">{error}</span>
              </div>
            )}

          {/* Navigation trail */}
          <div className="mb-4">
            <Link to="/admin/service" className="text-blue-500 hover:underline">
              Services
            </Link>
            <span className="mx-2 text-gray-500">→</span>
            <span className="text-gray-700 font-semibold">{serviceName}</span>
          </div>

          {/* Page Content */}
          <div className="bg-white flex ml-auto justify-end rounded-lg p-6">
            {/* Add Add-on Button */}
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
              onClick={toggleSlider}
            >
              Add-on
            </button>
          </div>

          {/* Display Saved Add-ons */}
          <div className="flex flex-col w-full mt-6">
            {addons.map((addon, index) => (
              <div
                key={index}
                className="bg-white p-4 shadow-md rounded-md mb-4 w-full"
              >
                <div className="flex justify-between items-center mb-4">
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg">
                      {addon.addon_service_name}
                    </h3>
                    <p className="text-gray-600">Price: ${addon.base_price}</p>
                  </div>

                  <div className="flex space-x-4">
                    <button
                      type="button"
                      onClick={() => toggleStatus(index)} // Toggle the status for the addon
                      className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center ${
                        addon.status === "D" ? "bg-gray-300" : "bg-green-500"
                      }`}
                    >
                      <div
                        className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${
                          addon.status === "D" ? "left-0.5" : "right-0.5"
                        }`}
                      />
                    </button>
                    <RiDeleteBin5Line
                      onClick={() => openDeleteModal(index)}
                      className="w-8 h-8 cursor-pointer text-red-500 hover:opacity-80"
                    />
                    <BiSolidEdit
                      onClick={() => handleEdit(index)}
                      className="w-8 h-8 cursor-pointer text-blue-500 hover:opacity-80"
                    />
                  </div>
                </div>

                {/* Edit form below the card */}
                {editIndex === index && (
                  <form
                    className="mt-4 space-y-4 w-full p-2 sm:p-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleEditSubmit(e);
                    }}
                  >
                    {/* Add-on Title */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Add-on Title
                      </label>
                      <input
                        type="text"
                        value={formData.title}
                        onChange={(e) =>
                          setFormData({ ...formData, title: e.target.value })
                        }
                        className="w-full sm:w-96 px-4 py-2 border rounded-md focus:outline-none focus:ring-4 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Add-on Description
                      </label>
                      <textarea
                        type="text"
                        value={formData.addon_service_description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addon_service_description: e.target.value,
                          })
                        }
                        className="w-full sm:w-96 px-4 py-2 border rounded-md focus:outline-none focus:ring-4 focus:ring-blue-500"
                      />
                    </div>

                    {/* Duration Fields */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Duration
                      </label>
                      <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
                        <input
                          type="number"
                          value={formData.hours}
                          onChange={(e) =>
                            setFormData({ ...formData, hours: e.target.value })
                          }
                          placeholder="Hours"
                          className="w-full sm:w-32 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <input
                          type="number"
                          value={formData.minutes}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              minutes: e.target.value,
                            })
                          }
                          placeholder="Minutes"
                          className="w-full sm:w-32 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>

                    {/* Service Image Upload */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Service Image
                      </label>
                      <input
                        type="file"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            serviceImage: e.target.files[0],
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md focus:outline-none"
                      />
                    </div>

                    {/* Select Service Dropdown */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Select Service
                      </label>
                      <select
                        value={selectedService}
                        onChange={(e) => setSelectedService(e.target.value)}
                        className="w-full sm:w-52 px-4 py-2 border rounded-md"
                      >
                        <option value="">Select a service</option>
                        {servicesList.map((service) => (
                          <option key={service.id} value={service.name}>
                            {service.icon} {service.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Price & Max Quantity */}
                    <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                      <div className="w-full sm:w-auto">
                        <label className="block text-sm font-medium text-gray-700">
                          Price
                        </label>
                        <input
                          type="number"
                          value={formData.price}
                          onChange={(e) =>
                            setFormData({ ...formData, price: e.target.value })
                          }
                          className="w-full sm:w-40 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div className="w-full sm:w-auto">
                        <label className="block text-sm font-medium text-gray-700">
                          Max Quantity
                        </label>
                        <input
                          type="number"
                          value={formData.maxqty}
                          onChange={(e) =>
                            setFormData({ ...formData, maxQty: e.target.value })
                          }
                          className="w-full sm:w-40 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>

                      <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium text-gray-700">
                      Enable Multiple Quantity
                    </label>
                    <button
                      type="button"
                      onClick={toggleMultipleQty}
                      className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center ${
                        formData.multipleQty === "Y" ? "bg-green-500" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`w-6 h-6 bg-white rounded-full absolute top-0 transition-all ${
                          formData.multipleQty === "Y" ? "right-0.5" : "left-0.5"
                        }`}
                      />
                    </button>
                  </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <button
                      type="submit"
                      className="mt-4 w-full sm:w-20 bg-blue-500 text-white text-base sm:text-sm px-4 py-2 rounded-md"
                    >
                      Save
                    </button>
                  </form>
                )}
              </div>
            ))}
          </div>
          {/* Slider for Add-on Form */}
          {isSliderOpen && (
            <div className="fixed inset-0 z-50 bg-gray-500 bg-opacity-50 flex justify-end items-center">
              <div className="bg-white w-ful h-full p-6  shadow-lg relative">
                <button
                  className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                  onClick={toggleSlider}
                >
                  X
                </button>
                <form onSubmit={handleFormSubmit}>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Add-on Title
                    </label>
                    <input
                      type="text"
                      value={formData.title}
                      onChange={(e) =>
                        setFormData({ ...formData, title: e.target.value })
                      }
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Duration
                    </label>
                    <div className="flex space-x-1">
                      <input
                        type="number"
                        value={formData.hours}
                        onChange={(e) =>
                          setFormData({ ...formData, hours: e.target.value })
                        }
                        placeholder="Hours"
                        className="w-1/2 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <input
                        type="number"
                        value={formData.minutes}
                        onChange={(e) =>
                          setFormData({ ...formData, minutes: e.target.value })
                        }
                        placeholder="Minutes"
                        className="w-1/2 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium py-3 text-gray-700">
                      Service Image
                    </label>
                    <input
                      type="file"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          serviceImage: e.target.files[0],
                        })
                      }
                      className="w-full px-4"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium py-3  text-gray-700">
                      Select Service
                    </label>
                    <select
                      value={selectedService}
                      onChange={(e) => setSelectedService(e.target.value)}
                      className="w-full px-4 py-2 border rounded-md"
                    >
                      <option value="">Select a service</option>
                      {servicesList.map((service) => (
                        <option key={service.id} value={service.name}>
                          {service.icon} {service.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex py-3 flex-row">
                    <label
                      htmlFor="price"
                      className="block text-sm px-2 py-3 font-medium text-gray-700"
                    >
                      Price
                    </label>
                    <input
                      type="number"
                      value={formData.price}
                      onChange={(e) =>
                        setFormData({ ...formData, price: e.target.value })
                      }
                      className="w-auto px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="maxQty"
                      className="block text-sm font-medium text-gray-700 py-3 "
                    >
                      Max Quantity
                    </label>
                    <input
                      type="text"
                      value={formData.maxqty}
                      onChange={(e) =>
                        setFormData({ ...formData, maxqty: e.target.value })
                      }
                      name="maxqty" // <-- Add this to match the PHP key
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium text-gray-700">
                      Enable Multiple Quantity
                    </label>
                    <button
                      type="button"
                      onClick={toggleMultipleQty}
                      className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center ${
                        formData.multipleQty === "Y" ? "bg-green-500" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`w-6 h-6 bg-white rounded-full absolute top-0 transition-all ${
                          formData.multipleQty === "Y" ? "right-0.5" : "left-0.5"
                        }`}
                      />
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="mt-4 w-full bg-blue-500 text-white px-4 py-2 rounded-md"
                  >
                    Save Add-on
                  </button>
                </form>
              </div>
            </div>
          )}

          {/* Delete Confirmation Modal */}
          {isDeleteModalOpen && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center p-4">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4">
                <h2 className="text-lg font-medium mb-4">Confirm Delete</h2>
                <p className="text-sm sm:text-base">
                  Are you sure you want to delete this?
                </p>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    className="px-4 py-2 bg-gray-500 text-white rounded-md text-sm sm:text-base"
                    onClick={cancelDelete}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 bg-red-500 text-white rounded-md text-sm sm:text-base"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      
    </div>
  );
};

export default Add;
